import { DataLayer } from "@sazka/utils/data-layer";

export namespace LegalWarningAnalytics {
    // DL4.00
    export function openPopupScreen() {
        DataLayer.push({
            event: "action.show.18screen",
        });
    }

    // DL4.01
    export function closePopupScreen() {
        DataLayer.push({
            event: "action.closeByCross.18screen",
        });
    }
}
